import React from 'react';
import moment from 'moment';
import { getTranslation } from '../../../../utils/translation';
import { renderTicketStatusName } from '../../../../utils/render';
import Status from '../../../shared/Status/Status';
import { TICKET_STATUSES } from '../../../../constants/enums';
import { useDispatch } from 'react-redux';
import { changeTicketModalProps } from '../../../../store/actions/tickets';

export default function Table({ tickets }) {
    const dispatch = useDispatch();

    const getStatusTheme = statusId => {
        switch (statusId) {
            case TICKET_STATUSES.open:
            case TICKET_STATUSES.cashOut:
                return 'info';
            case TICKET_STATUSES.cancelled:
            case TICKET_STATUSES.draw:
            case TICKET_STATUSES.refunded:
                return 'neutral';
            case TICKET_STATUSES.won:
            case TICKET_STATUSES.void:
            case TICKET_STATUSES.paid:
                return 'success';
            case TICKET_STATUSES.lost:
                return 'danger';
            default:
                return '';
        }
    };

    const onDetailsClick = ticketCode => {
        dispatch(changeTicketModalProps({ isVisible: true, ticketCode }));
    };

    return (
        <table className={'point-table'}>
            <thead>
                <tr align='center'>
                    <th>{getTranslation('ticketsTableNoColumn')}</th>
                    <th>{getTranslation('ticketsTableStatusColumn')}</th>
                    <th>{getTranslation('ticketsTableTerminalColumn')}</th>
                    <th>{getTranslation('ticketsTableBetIdColumn')}</th>
                    {/*<th>{getTranslation('ticketsTableBarcodeColumn')}</th>*/}
                    <th>{getTranslation('ticketsTableTimeColumn')}</th>
                    <th>{getTranslation('ticketsTableTicketCostColumn')}</th>
                    <th>{getTranslation('ticketsTableMaxWinColumn')}</th>
                    <th>{getTranslation('ticketsTableBetTypeColumn')}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {tickets.map((ticket, index) => (
                    <tr align='center' key={index}>
                        <td className='td-number'>{index + 1}</td>
                        <td>
                            <Status
                                status={getStatusTheme(ticket.status)}
                                title={renderTicketStatusName(ticket.status)}
                            />
                        </td>
                        <td>{ticket.terminalCode || ticket.issuedAgent}</td>
                        <td>{ticket.ticketId}</td>
                        {/*<td>{ticket.code}</td>*/}
                        <td>{moment(ticket.issuedDate).format('DD/MM/YYYY HH:mm:ss')}</td>
                        <td>{ticket.totalStake} AZN</td>
                        <td>{ticket.totalWin} AZN</td>
                        <td>{ticket.ticketType}</td>
                        <td>
                            <button
                                className='detailsBtn'
                                onClick={() => onDetailsClick(ticket.code)}
                            >
                                <span>{getTranslation('ticketsTableDetailsButton')}</span>
                                <span className='icon-arrow-down' />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
